import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';

class CommunityNavigation extends React.PureComponent {
  static propTypes = {
    activeTab: PropTypes.oneOf(['home', 'profile', 'institution', 'connections', 'groups']).isRequired,
  };

  state = { open: false };

  getActiveClass(tab) {
    if (tab === this.props.activeTab) {
      return styles.active;
    }
    return '';
  }

  getMenuClass() {
    return this.state.open ? styles['main-nav-open'] : styles['main-nav'];
  }

  toggleMenu = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  render() {
    return (
      <div styleName="navigation">
        <div styleName="section">
          <a id="nav-toggle" href="javacript:;" onClick={this.toggleMenu} styleName="nav-toggle">Toggle Nav</a>
          <ul id="main-menu" className={this.getMenuClass()}>
            <li className={`first ${this.getActiveClass('home')}`} styleName="tab">
              <Link to="/community/" styleName="tabLink">
                <FormattedMessage id="community.link.home" defaultMessage="Home" />
              </Link>
            </li>
            <li className={this.getActiveClass('profile')} styleName="tab">
              <Link to="/community/profile" className={this.getActiveClass('profile')} styleName="tabLink">
                <FormattedMessage id="community.link.profile" defaultMessage="Profile" />
              </Link>
            </li>
            <li className={this.getActiveClass('institution')} styleName="tab">
              <Link to="/community/institution" className={this.getActiveClass('institution')} styleName="tabLink">
                <FormattedMessage id="community.link.institution" defaultMessage="Institution" />
              </Link>
            </li>
            <li className={this.getActiveClass('connections')} styleName="tab">
              <Link to="/community/connections" className={this.getActiveClass('connections')} styleName="tabLink">
                <FormattedMessage id="community.link.connections" defaultMessage="Connections" />
              </Link>
            </li>
            <li className={this.getActiveClass('groups')} styleName="tab">
              <Link to="/community/groups" className={this.getActiveClass('groups')} styleName="tabLink">
                <FormattedMessage id="community.link.groups" defaultMessage="Groups" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default CommunityNavigation;
